angular.module('am4').controller('profileCtrl', function($scope, $state, UserService, config, subscriptions, subscriptionService, errorService, profileService) {
    var that = this,
        oldSettings;

    $scope.initLoading = true;

    profileService.getSettings()
    .then(function(settings) {
        that.settings = settings;
        oldSettings = angular.copy(settings);
    })
    .finally(function() {
        $scope.initLoading = false;
    });

    that.languages = config.languages;
    that.units = config.units;

    that.subscriptions = subscriptions;
    $scope.$on('subscriptions:update', function() {
        UserService.user
        .then(function(user) {
            return subscriptionService.getUserSubscriptions(user.user_id);
        })
        .then(function(subscriptions) {
            that.subscriptions = subscriptions;
        })
        .catch(function(e) {
            errorService.addError('UPDATE_SUBSCRIPTIONS_ERROR', e);
        });
    });

    that.submitSettings = function() {
        $scope.settingsLoading = true;
        that.settingsChangeSuccess = false;

        UserService.user.then(function(user) {
            return profileService.updateSettings(user.user_id, that.settings);
        })
        .then(function successfulSettingsChange() {
            oldSettings = angular.copy(that.settings);

            that.settingsChangeSuccess = true;

            return UserService.loadUser().then(function() {
                $state.reload();
            });
        })
        .catch(function errorSettingsChange(e) {
            errorService.addError('PROFILE_SETTINGS_ERROR', e);

            that.settings = angular.copy(oldSettings);
        })
        .finally(function finallySettingsChange() {
            $scope.settingsForm.$rollbackViewValue();
            $scope.settingsForm.$setPristine();
            $scope.settingsForm.$setUntouched();
            $scope.settingsLoading = false;
        });
    };

    that.submitPassword = function() {
        $scope.passwordLoading = true;

        UserService.user.then(function(user) {
            return profileService.updatePassword(user.user_id, that.password.newPassword, that.password.oldPassword);
        })
        .then(function successfulPasswordChange() {

        })
        .catch(function failurePasswordChange(e) {
            errorService.addError('PROFILE_PASSWORD_ERROR', e);
        })
        .finally(function finallyPasswordChange() {
            $scope.passwordForm.$rollbackViewValue();
            $scope.passwordForm.$setPristine();
            $scope.passwordForm.$setUntouched();
            that.password = {};
            $scope.passwordLoading = false;
        });
    };

    that.unsubscribe = function(id, e) {
        // Do not bubble to 'edit the row' click listener
        e.stopPropagation();
        e.preventDefault();

        UserService.user
        .then(function(user) {
            return subscriptionService.deleteUserSubscription(user.user_id, id);
        })
        .then(function() {
            $scope.$emit('subscriptions:update');
        });
    };
});



// WEBPACK FOOTER //
// ./src/app/controllers/profileCtrl.js